// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"category-page-title_wrapper__00H2u","wrapper__cover":"category-page-title_wrapper__cover__QhBLM","wrapper__title":"category-page-title_wrapper__title__kG9fM"};